import router from '@/router';
import axios from 'axios'
import { ElMessage } from 'element-plus';
import { ElMessageBox } from 'element-plus'
import { useAuthStore } from '@/stores/auth'
import { isValidJWTFormat } from '@/utils/jwt'

export const BASE_URL = 'https://macroeco.jxufe.edu.cn/api'; // 服务器地址(对外开放)
export const GPU_URL = 'https://macroeco.jxufe.edu.cn/rag';
export const RSHINY_URL = 'https://macroeco.jxufe.edu.cn/shiny'
export const ONLYOFFICE_SERVER_URL = 'https://macroeco.jxufe.edu.cn/editor'
export const GEO_BASE_URL = 'http://172.29.160.9:8008'
export const MAP_TILE_URL = 'http://172.29.160.9:3000'

const request = axios.create({
    baseURL: BASE_URL,
    timeout: 2880000,
    withCredentials: true,  // 必须为true
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        // 'Connection': 'keep-alive'
    }
})

// request拦截器
request.interceptors.request.use(
    config => {
        // get请求避免缓存加上时间戳
        if (config.method === 'get') {
            if (typeof config.url === 'string') {
                if (config.url.includes("?")) {
                    config.url = config.url + '&t=' + Date.now();
                } else {
                    config.url = config.url + '?timestamp=' + Date.now();
                }
            }
        }

        return config
    },
    error => {
        return Promise.reject(error)
    }
)



let redirecting = false
let reloginDialogShowing = false

request.interceptors.response.use(
  async (response) => {
    const res = response.data

        // ✅ 临时模拟：只要请求包含 get_news 就伪造超时
    // if (typeof response.config.url === 'string' && response.config.url.includes('get_news')) {
    //   res.code = 2
    //   res.message = '登录超时，请重新登录'
    // }

    // 只处理统一结构：{ code, message, data }
    if (res && typeof res.code !== 'undefined') {
      // 业务码 2：登录超时/未登录
     if (res.code === 2) {
  // ✅ 清 Pinia（头像等 UI 才会立刻变为未登录）
  const auth = useAuthStore()
  auth.logout() // 你已经在 logout 里清 localStorage 了

  // 防止重复弹框
if (!reloginDialogShowing) {
  reloginDialogShowing = true
  const redirect = router.currentRoute.value.fullPath

  try {
    await ElMessageBox.confirm(
      res.message || '登录超时，请重新登录',
      '请先登录',
      {
        confirmButtonText: '去登录',
        showCancelButton: false,
        showClose: true,           // ✅ 允许右上角 X
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning',
      }
    )

    // 点“去登录”
    router.replace({ path: '/login', query: { redirect } })
  } catch {
    // 点 X 关闭 / 其它关闭方式：也跳登录
    router.replace({ path: '/login', query: { redirect } })
  } finally {
    reloginDialogShowing = false
  }
}


  return Promise.reject(new Error(res.message || '登录超时'))
}


      // 成功码是 1；其它业务码按失败处理（可按约定调整）
      if (res.code !== 1) {
        return Promise.reject(new Error(res.message || '请求失败'))
      }
    }

    // 正常返回业务体（你原先就是返回 response.data）
    return res
  },
  (error) => {
    // 保留你原来的 HTTP 401/403/500 处理
    let errResponse = error.response
    try {
      switch (errResponse.status) {
        case 401:
          console.log('response status:', 401)
          break
        case 403:
          console.log('response status:', 403)
          break
        case 500:
          console.log('response status:', 500)
          break
        default:
          console.log('default response status')
      }
    } catch (e) {}
    return Promise.reject(error)
  }
)

export default request


const gpu_request = axios.create({
    baseURL: GPU_URL,
    timeout: 2880000,
    // withCredentials: true,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    }
})

// request拦截器
gpu_request.interceptors.request.use(
    config => {
     
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// response拦截器（这个不用变）
gpu_request.interceptors.response.use(
    response => {
        console.log('response:', response)
        return response
    },
    error => {  
        let errResponse = error.response;
        try {
            switch (errResponse.status) {
                case 401:
                    console.log('response status:', 401);
                    break;
                case 403:
                    console.log('response status:', 403);
                    break;
                case 500:
                    console.log('response status:', 500);
                    break;
                default:
                    console.log('default response status');
            }
        } catch (e) {}
        return Promise.reject(error)
    }
)
export { gpu_request };

// 登录请求拦截
request.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken')
  const tokenType = localStorage.getItem('tokenType') || 'Bearer'

  // 只给“JWT格式正确”的 token 加 Authorization
  if (isValidJWTFormat(token)) {
    config.headers = config.headers || {}
    config.headers.Authorization = `${tokenType} ${token}`
  } else {
    // token 存在但不是 JWT 格式：当作脏数据，清掉
    if (token) {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('tokenType')
      localStorage.removeItem('expiresAt')
      localStorage.removeItem('auth')
    }
  }

  return config
})